import React from 'react'
import { useModelKey, useValue } from '@morningtrain/react-resources'
import useCart from 'services/cart/hooks/use-cart'
import useAddToCart from 'services/googleAnalytics/use-add-to-cart'
import useRemoveFromCart from 'services/googleAnalytics/use-remove-from-cart'

export default function EditQuantity () {
  const cart = useCart()

  const id = useModelKey()
  const name = useValue('domain')
  const price = useValue('discounted_price')
  const defaultCount = cart.get(id ? id.toString() : null)

  const [count, setCount] = React.useState(defaultCount)

  React.useEffect(() => {
    const currentCount = cart.get(id.toString()) || 0

    count > 0
      ? cart.set(id.toString(), count)
      : cart.delete(id.toString())

    if (count > currentCount) {
      useAddToCart(
        id,
        name,
        price,
        (count - currentCount)
      )
    } else if (count < currentCount) {
      useRemoveFromCart(
        id,
        name,
        price,
        (currentCount - count)
      )
    }
  }, [count])

  return (
    <div className='quantity-input'>
      <div onClick={() => setCount(count - 1)} className='quantity-input__btn-wrap'>
        <button>-</button>
      </div>

      <div className='quantity-input__text'>
        <input value={count} onChange={e => setCount(parseInt(e.target.value) || count)} />
      </div>

      <div onClick={() => setCount(count + 1)} className='quantity-input__btn-wrap'>
        <button>+</button>
      </div>
    </div>
  )
}
